import type { PlanningUserAssignment } from '../../../../api/userAssignmentApis';
import type {
  AssignLocationOption,
  AssignTaskOption,
  AssignUserOption,
} from './assignUsersTypes';

export const MOCK_ASSIGN_USERS: AssignUserOption[] = [
  { value: 'FBT_USR_PRH', label: 'Prashanth H L' },
  { value: 'FBT_USR_RAK', label: 'Rakesh HM' },
  { value: 'FBT_USR_ANJ', label: 'Anjali Rao' },
  { value: 'FBT_USR_VIK', label: 'Vikram Shah' },
  { value: 'FBT_USR_MEG', label: 'Megha Patel' },
];

export const MOCK_ASSIGN_LOCATIONS: AssignLocationOption[] = [
  { value: 'loc-tower-a', label: 'Tower A', depth: 0 },
  {
    value: 'loc-floor-1a',
    label: 'Floor 1',
    depth: 1,
    breadcrumb: 'Tower A',
  },
  {
    value: 'loc-floor-2a',
    label: 'Floor 2',
    depth: 1,
    breadcrumb: 'Tower A',
  },
  { value: 'loc-tower-b', label: 'Tower B', depth: 0 },
  {
    value: 'loc-floor-1b',
    label: 'Floor 1',
    depth: 1,
    breadcrumb: 'Tower B',
  },
  { value: 'loc-basement', label: 'Basement', depth: 0 },
];

export const MOCK_ASSIGN_TASKS: AssignTaskOption[] = [
  {
    id: 'task-slab-f1',
    label: 'Slab pour',
    locationId: 'loc-floor-1a',
    breadcrumb: 'Tower A › Floor 1',
  },
  {
    id: 'task-blockwork-f1',
    label: 'Block work',
    locationId: 'loc-floor-1a',
    breadcrumb: 'Tower A › Floor 1',
  },
  {
    id: 'task-slab-f1b',
    label: 'Slab pour',
    locationId: 'loc-floor-1b',
    breadcrumb: 'Tower B › Floor 1',
  },
  {
    id: 'task-slab-f2',
    label: 'Slab pour',
    locationId: 'loc-floor-2a',
    breadcrumb: 'Tower A › Floor 2',
  },
  {
    id: 'task-no-loc',
    label: 'Unlocated activity',
    locationId: null,
  },
];

export function createMockAssignments(): PlanningUserAssignment[] {
  return [
    {
      id: 'mock-asg-1',
      projectId: 'mock-project',
      scopeType: 'location',
      locationId: 'loc-floor-1a',
      taskId: null,
      userId: 'FBT_USR_PRH',
      userName: 'Prashanth H L',
      role: 'planner',
      status: 'active',
      createdAt: '2026-09-25T09:20:48.900068',
      updatedAt: '2026-09-25T09:20:48.900068',
    },
    {
      id: 'mock-asg-2',
      projectId: 'mock-project',
      scopeType: 'task',
      locationId: 'loc-floor-1a',
      taskId: 'task-slab-f1',
      userId: 'FBT_USR_ANJ',
      userName: 'Anjali Rao',
      role: 'capturer',
      status: 'active',
      createdAt: '2026-09-25T10:00:00.000000',
      updatedAt: '2026-09-25T10:00:00.000000',
    },
  ];
}
